<template>
  <fragment>
    <h5 class="my-3">填写购买信息</h5>
    <p class="mb-lg-4">
      亲爱的学员，请准确填写您的个人信息，信息一旦提交，将不能修改。如需帮助，请联系客服人员或致信
      <a href="mailto:support@pzacademy.com">support@pzacademy.com</a>
    </p>

    <form name="wechatForm" class="form-horizontal" role="form">
      <!-- <div class="form-group row" :class="{ 'has-error': c_isUsernameToolong }">
                    <label class="col-lg-3 control-label">姓名</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        name="username"
                        v-model="username"
                        class="form-control"
                      />
                      <p class="grey-500 font-14 m-t-5">请填写您的真实姓名，以便加您进入品职学习交流群后帮您更改群昵称</p>
                      <p v-show="c_isUsernameToolong" class="help-block">姓名过长</p>
                    </div>
                  </div>-->
      <template v-if="!c_hasWechatNo">
        <div class="form-group row" :class="{ 'has-error': c_isWechatToolong }">
          <label class="col-lg-3 control-label">微信号</label>
          <div class="col-lg-9">
            <input
              type="text"
              name="wechat"
              size="50"
              v-model="wechat"
              class="form-control"
            />
            <p class="grey-500 font-14 m-t-5">
              请填写您的真实微信号，以便能及时添加您到品职学习交流群
            </p>
            <p v-show="c_isWechatToolong" class="help-block">微信号过长</p>
          </div>
        </div>
      </template>
      <template v-if="!c_hasMobile">
        <div class="form-group row" :class="{ 'has-error': c_isMobileWrong }">
          <label class="col-lg-3 control-label">手机号</label>
          <div class="col-lg-9">
            <div class="input-group reg-phone">
              <span class="input-group-btn">
                <button
                  ng-init="country='+86'"
                  @click.prevent="showCountriesList"
                  type="button"
                  class="btn btn-outline-secondary"
                  id="btnShowCountriesList"
                >
                  {{ country }}&nbsp;
                  <span class="caret"></span>
                </button>
              </span>
              <input
                :readonly="infoValided"
                class="form-control"
                name="mobile"
                ng-pattern="/^\d{1,}$/"
                type="mobile"
                required
                v-model="mobile"
              />
              <div
                class="reg-phone-list"
                ref="regPhoneList"
                style="display: none"
              >
                <div class="reg-phone-list-group">
                  <div class="list-group">
                    <span class="list-group-divider">常用</span>
                    <a
                      :key="c.countryOrder"
                      v-for="c in ms_countries"
                      href="javascript:undefined"
                      @click.prevent="selectCountry(c)"
                      class="list-group-item list-group-item-action"
                    >
                      {{ c.countryName }}
                      <span class="pull-right">{{ c.countryNumber }}</span>
                    </a>
                  </div>
                </div>
                <div class="reg-phone-list-cancel">
                  <button
                    type="button"
                    name
                    id
                    class="btn btn-secondary btn-block"
                  >
                    取消
                  </button>
                </div>
              </div>
            </div>

            <p class="grey-500 font-14 m-t-5">
              请您填写个人手机号码，以收取短信验证码核实您的身份
            </p>
            <p v-show="c_isMobileWrong" class="help-block">请输入有效手机号</p>
          </div>
        </div>
        <div class="form-group row" :class="{ 'has-error': isSmsCaptchaWrong }">
          <label for="smsCaptcha" class="col-lg-3 control-label"
            >短信验证码</label
          >
          <div class="col-lg-9">
            <div class="input-group">
              <input
                :readonly="infoValided"
                type="input"
                name="smsCaptcha"
                ng-maxlength="6"
                ng-minlength="6"
                ng-required="!partAuth"
                class="form-control"
                v-model="smsCaptcha"
                @change="handleSmsCaptchaChange"
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-primary btn-outline"
                  :disabled="!c_isMobileReady"
                  data-toggle="modal"
                  @click.prevent="getCaptcha"
                >
                  获取验证码
                </button>
              </span>
            </div>

            <p v-show="isSmsCaptchaWrong" class="help-block">
              请输入有效短信验证码
            </p>
          </div>
        </div>
      </template>

      <template v-if="!c_hasEmail">
        <div
          class="form-group row"
          :class="{
            'has-error': c_isEmailInvalid || isEmailDuplicate,
          }"
        >
          <label class="col-lg-3 control-label">邮箱地址</label>
          <div class="col-lg-9">
            <input
              type="text"
              required
              ng-blur="validateEmail()"
              ng-maxlength="50"
              size="50"
              name="email"
              v-model="email"
              class="form-control"
              @input="handleInputEmail"
            />
            <p class="grey-500 font-14 m-t-5">请填写您的有效邮箱地址。</p>
            <p v-show="c_isEmailInvalid" class="text-danger">请输入有效邮箱</p>
            <p v-show="isEmailDuplicate" class="text-danger">邮箱已注册</p>
          </div>
        </div>
        <template v-if="!c_hasPassword">
          <div
            class="form-group row"
            :class="{ 'has-error': !c_isNewPasswordReady }"
          >
            <label class="col-lg-3 control-label">登录密码</label>
            <div class="col-lg-9">
              <input
                :type="isShowNewPassword ? 'text' : 'password'"
                ng-maxlength="50"
                size="50"
                name="password"
                v-model="newPassword"
                @input="handleInputNewPassword"
                autocomplete="off"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-link border text-dark btn-password phone-code"
                  type="button"
                  data-toggle="button"
                  aria-pressed="false"
                  @click.prevent="toggleNewPassword"
                >
                  <svg width="24px" height="24px" viewBox="0 0 24 24">
                    <g id="off" class="off" fill="#666666" fill-rule="nonzero">
                      <path
                        d="M12.0719496,14.4139103 C7.88448087,14.4139103 3.98001398,12.1594884 1.87908464,8.53082843 C1.57209954,8.00079945 1.75437195,7.32447288 2.28200259,7.01748776 C2.81203158,6.71050266 3.49075648,6.89277506 3.79534327,7.42040571 C5.50054962,10.3655441 8.6711302,12.1954632 12.0695513,12.1954632 C15.4679724,12.1954632 18.638553,10.3655441 20.3437594,7.4180074 C20.6507445,6.88797841 21.3270711,6.70570601 21.8571,7.01269111 C22.387129,7.31967621 22.5670031,7.9960028 22.2624163,8.52603178 C20.1638853,12.1594884 16.2594184,14.4139103 12.0719496,14.4139103 Z M6.33036874,15.517138 C6.13610473,15.517138 5.93704406,15.4667733 5.7595683,15.3588488 C5.23433597,15.0422704 5.06645348,14.3611472 5.38303188,13.8383132 L6.60617569,11.8141301 C6.92275409,11.2888978 7.6038773,11.1234136 8.1267113,11.4375937 C8.65194363,11.7541721 8.81982612,12.4352953 8.50324772,12.9581293 L7.28010394,14.9823124 C7.07145,15.3252723 6.70690519,15.517138 6.33036874,15.517138 L6.33036874,15.517138 Z M17.7535725,15.517138 C17.3794344,15.517138 17.0124913,15.3276706 16.8038373,14.9823124 L15.5806935,12.9581293 C15.2641151,12.432897 15.4319976,11.7541721 15.9548316,11.4375937 C16.4800639,11.1210153 17.1587888,11.2888978 17.4753672,11.8117318 L18.698511,13.8359149 C19.0150894,14.3611472 18.847207,15.0398721 18.3243729,15.3564505 C18.1468972,15.4643749 17.9478365,15.517138 17.7535725,15.517138 Z M12.0719496,16.958529 C11.4603777,16.958529 10.9639252,16.4620765 10.9639252,15.8505046 L10.9639252,13.3058859 C10.9639252,12.694314 11.4603777,12.1978615 12.0719496,12.1978615 C12.6835215,12.1978615 13.179974,12.694314 13.179974,13.3058859 L13.179974,15.8505046 C13.179974,16.4620765 12.6835215,16.958529 12.0719496,16.958529 Z"
                      />
                    </g>
                    <g id="on" class="on" fill="#666666" fill-rule="nonzero">
                      <path
                        d="M23.8766667,11.2666667 C23.8766667,11.2666667 23.7766667,10.9666667 23.6766667,10.8666667 L23.1766667,9.86666667 C22.6766667,9.06666668 21.9766667,8.06666667 20.9766667,6.96666666 C19.0766667,4.86666666 16.0766667,2.66666667 11.9766667,2.66666667 C7.87666664,2.66666667 4.87666666,4.86666668 2.97666666,6.96666666 C1.97666665,8.06666665 1.27666666,9.06666666 0.776666672,9.86666667 C0.57666668,10.2666667 0.376666664,10.5666667 0.276666656,10.8666667 C0.176666648,10.9666667 0.0766666641,11.2666667 0.0766666641,11.2666667 C-0.0233333437,11.5666667 -0.0233333437,11.8666667 0.0766666641,12.0666667 C0.0766666641,12.0666667 0.176666672,12.3666667 0.276666656,12.4666667 L0.776666672,13.4666667 C1.27666666,14.2666667 1.97666667,15.2666667 2.97666666,16.3666667 C4.87666666,18.4666667 7.87666666,20.6666667 11.9766667,20.6666667 C16.0766666,20.6666667 19.0766666,18.4666667 20.9766667,16.3666667 C21.9766667,15.2666667 22.6766666,14.2666667 23.1766667,13.4666667 C23.3766667,13.0666667 23.5766667,12.7666667 23.6766667,12.4666667 C23.7766667,12.3666667 23.8766666,12.0666667 23.8766667,12.0666667 C23.9766667,11.7666667 23.9766667,11.5666667 23.8766667,11.2666667 Z M21.4766667,12.3666667 C21.0766667,13.0666667 20.3766667,14.0666666 19.5766667,14.9666667 C17.7766667,16.8666667 15.2766667,18.6666667 11.9766667,18.6666667 C8.67666666,18.6666667 6.17666665,16.8666667 4.37666667,14.9666667 C3.47666667,14.0666667 2.87666667,13.0666667 2.47666666,12.3666667 C2.27666667,12.0666667 2.17666666,11.8666667 2.07666666,11.6666667 C2.17666666,11.4666667 2.27666665,11.2666667 2.47666666,10.9666667 C2.97666666,10.2666667 3.57666666,9.26666667 4.37666667,8.36666667 C6.17666667,6.46666666 8.67666666,4.66666666 11.9766667,4.66666666 C15.2766667,4.66666666 17.7766667,6.46666666 19.5766667,8.36666667 C20.4766667,9.26666667 21.0766667,10.2666667 21.4766667,10.9666667 C21.6766667,11.2666667 21.7766667,11.4666667 21.8766667,11.6666667 C21.7766666,11.8666667 21.5766667,12.0666667 21.4766667,12.3666667 Z"
                      />
                      <path
                        d="M11.9766667,8.06666667 C10.1766667,8.06666667 8.57666667,9.66666668 8.57666667,11.6666667 C8.57666667,13.6666667 10.1766667,15.2666667 11.9766667,15.2666667 C13.7766667,15.2666667 15.3766667,13.6666667 15.3766667,11.6666667 C15.3766667,9.66666668 13.7766667,8.06666667 11.9766667,8.06666667 Z M6.57666666,11.6666667 C6.57666666,8.66666667 8.97666666,6.06666666 11.9766667,6.06666666 C14.9766667,6.06666666 17.3766667,8.66666665 17.3766667,11.6666667 C17.3766667,14.6666667 14.9766667,17.2666667 11.9766667,17.2666667 C8.97666666,17.2666667 6.57666666,14.6666667 6.57666666,11.6666667 Z"
                      />
                    </g>
                  </svg>
                </button>
              </div>
              <p class="small text-danger" v-show="c_isShowNewPasswordInvalid">
                密码应为至少8位的数字和字母组合。
              </p>
            </div>
          </div>
        </template>
      </template>
    </form>

    <!-- <div class="col-md-5 col-lg-4 d-none d-md-block">
                <div class="text-center py-4 border-left" role="alert">
                  <h6 class="alert-heading mb-3">需要帮助？请扫码</h6>
                  <img
                    src="https://resources.pzacademy.com/image/qrcode/qrcode-sales.png"
                    width="140"
                    height="140"
                  />
                  <p class="small">
                    微信扫描二维码后
                    <br />回复【你好】获得帮助。
                  </p>
                  <img
                    src="https://resources.pzacademy.com/image/qrcode/qrcode-robot.jpg"
                    width="140"
                    height="140"
                  />
                  <p class="small">
                    微信扫描二维码后
                    <br />回复【小课】获得帮助。
                  </p>
                </div>
              </div> -->
    <div class="text-center">
      <button class="btn btn-light mx-2 px-4" @click.prevent="skip">
        跳过
      </button>
      <button
        class="btn btn-primary mx-2 px-4"
        :disabled="!c_isStep1FormReady || isBtnLoading"
        @click.prevent="toStep2"
      >
        {{ isBtnLoading ? '保存中...' : '提交' }}
      </button>
    </div>

    <!-- /.modal 发送验证码-->
    <div
      class="modal fade"
      data-backdrop="static"
      id="captchaModal2"
      ref="captchaModal2"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div
            class="
              modal-header
              d-flex
              justify-content-between
              px-3
              align-items-center
            "
          >
            <h6 class="page-heading">发送验证码</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form name="captchaForm" novalidate>
              <div
                style="form-group"
                :class="{ 'has-error': objError.captchaError }"
              >
                <div class="row">
                  <div class="offset-2 col-4">
                    <input
                      type="captcha"
                      name="captcha"
                      required
                      class="form-control input-lg"
                      style="border-radius: 0"
                      v-model="captcha"
                      placeholder="验证码"
                    />
                    <p v-show="objError.captchaError" class="help-block">
                      验证码错误
                    </p>
                  </div>
                  <div class="col-6">
                    <img
                      style="width: 150px; height: 45px"
                      :src="captchaSource"
                    />
                    <a @click.prevent="refresh" style="cursor: pointer"
                      >换一张</a
                    >
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="offset-2 col-8" style="padding: 20px 14px">
                    <button
                      type="button"
                      class="btn btn-primary btn-block btn-lg"
                      :disabled="!c_isCaptchaReady"
                      @click.prevent="sendCaptcha"
                    >
                      获取手机验证码
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </fragment>
</template>
<script>
import $ from 'jquery';
//import { debounce } from 'lodash';
//import { mapGetters, mapActions } from 'vuex';
import { DEFAULT_DATA_URL } from '@/constants/index';
import { SettingMixin } from '@/mixins/Setting';
import { /* swalSuccess */ swalWarning } from '@/utils/swal2';

export default {
  name: 'FirstBuy',

  mixins: [SettingMixin],

  props: {
    //
  },

  data() {
    return {
      username: '',
      country: '+86',
      mobile: '',
      smsCaptcha: '',
      objError: {
        captchaError: false,
      },
      captcha: '',
      captchaSource: DEFAULT_DATA_URL,
      isSmsCaptchaWrong: false,
      //
      isBtnLoading: false,
    };
  },

  computed: {
    //...mapGetters({
    //  userInfo: 'userInfo',
    //}),

    c_isStep1FormReady() {
      let isStep1FormReady = /* this.c_isUsernameReady && */ true;
      if (!this.c_hasWechatNo) {
        isStep1FormReady = isStep1FormReady && this.c_isWechatReady;
      }
      if (!this.c_hasEmail) {
        isStep1FormReady = isStep1FormReady && this.c_isEmailReady;
        if (!this.c_hasPassword) {
          isStep1FormReady = isStep1FormReady && this.c_isNewPasswordReady;
        }
      }
      return isStep1FormReady;
    },

    c_isUsernameBlank() {
      return Boolean(!this.username);
    },

    c_isUsernameToolong() {
      return !this.c_isUsernameBlank && this.username.length > 50;
    },

    c_isUsernameReady() {
      return !this.c_isUsernameBlank && !this.c_isUsernameToolong;
    },

    c_isMobileBlank() {
      return Boolean(!this.mobile);
    },

    c_isMobileWrong() {
      return !this.c_isMobileBlank && this.mobile.match(/^\d{1,}$/) === null;
    },

    c_isMobileReady() {
      return !this.c_isMobileBlank && !this.c_isMobileWrong;
    },

    c_longMobile() {
      return this.country + this.mobile;
    },

    c_isSmsCaptchaBlank() {
      return Boolean(!this.smsCaptcha);
    },

    c_isSmsCaptchaReady() {
      return !this.c_isSmsCaptchaBlank && !this.isSmsCaptchaWrong;
    },

    c_isCaptchaReady() {
      return Boolean(this.captcha);
    },
  },

  watch: {
    captcha() {
      this.objError.captchaError = false;
    },

    smsCaptcha() {
      this.isSmsCaptchaWrong = false;
    },
  },

  methods: {
    _setHideCountriesList() {
      setTimeout(() => {
        $('body').one('click', this.hideCountriesList);
      }, 0);
    },

    hideCountriesList(e) {
      if (
        0 !== $(e.target).parents('#btnShowCountriesList').length ||
        'btnShowCountriesList' === $(e.target).attr('id')
      ) {
        this._setHideCountriesList();
        return false;
      }
      $(this.$refs.regPhoneList).hide();
    },

    showCountriesList() {
      $(this.$refs.regPhoneList).show();
      this._setHideCountriesList();
    },

    selectCountry(c) {
      this.country = c.countryNumber;
    },

    refresh() {
      this.captchaSource = '/api/captcha?' + Date.now();
    },

    getCaptcha() {
      $(this.$refs.captchaModal2).modal('show');
      this.captcha = '';
      this.refresh();
    },

    async sendCaptcha() {
      this.c_longMobile;
      const res = await this.ma_getMobileCode({
        mobile: this.c_longMobile,
        captcha: this.captcha,
      });
      if (res.data.status == -2) {
        this.objError.captchaError = true;
        this.refresh();
      } else {
        $(this.$refs.captchaModal2).modal('toggle');
        $('.modal-backdrop').hide();
      }
    },

    handleSmsCaptchaChange() {
      this.isSmsCaptchaWrong =
        !this.c_isSmsCaptchaBlank && this.smsCaptcha.match(/^\d{6}$/) === null;
    },

    emitFinished() {
      this.$emit('finished');
    },

    async toStep2() {
      if (!this.c_isStep1FormReady) {
        return;
      }
      this.isBtnLoading = true;
      let payload = {
        wechat: !this.c_hasWechatNo ? this.wechat : undefined,
      };
      let res;
      if (!this.c_hasEmail) {
        payload = {
          ...payload,
          email: this.email,
          password: !this.c_hasPassword ? this.newPassword : undefined,
        };
        res = await this.ma_prepurchaseFromWechat(payload);
      } else {
        res = await this.ma_prepurchaseFromEmail(payload);
      }
      if (res.data.status != 200) {
        swalWarning(res.data.message);
      } else {
        this.emitFinished();
      }
      this.isBtnLoading = false;
    },

    skip() {
      this.emitFinished();
    },
  },

  created() {
    this.ma_getMallCountries();
  },

  beforeDestroy() {
    $('body').off('click', this.hideCountriesList);
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
